import React, { useEffect, useState } from "react";

type GridIconProps = {
  size?: string | number;
  type?: "grid" | "list";
  active?: boolean;
  className?: string;
  onClick?: () => void;
};

export function GridIcon({
  size = "28",
  type = "grid",
  active = false,
  className,
  onClick,
}: GridIconProps) {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return;

    const updateTheme = () => {
      setDarkMode(document.documentElement.classList.contains("dark"));
    };

    updateTheme();

    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const color = active
    ? darkMode
      ? "#fb923c"
      : "#0284c7"
    : darkMode
      ? "#52525b"
      : "#cbd5e1";

  switch (type) {
    case "grid":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 28 28"
          width={size}
          height={size}
          fill="none"
          className={className}
          onClick={onClick}
        >
          <rect x="0" y="0" width="28" height="28" rx="3" ry="3" fill={color} />
          <rect x="8" y="8" width="5" height="5" fill="#f2f2f2" />
          <rect x="15" y="8" width="5" height="5" fill="#f2f2f2" />
          <rect x="8" y="15" width="5" height="5" fill="#f2f2f2" />
          <rect x="15" y="15" width="5" height="5" fill="#f2f2f2" />
        </svg>
      );

    case "list":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 28 28"
          width={size}
          height={size}
          fill="none"
          stroke={color}
          strokeWidth="2"
          className={className}
          onClick={onClick}
        >
          <rect x="0" y="0" width="28" height="28" rx="3" ry="3" fill={color} strokeWidth="0" />
          <rect x="6" y="8" width="16" height="2" fill="#f2f2f2" strokeWidth="0" />
          <rect x="6" y="13" width="16" height="2" fill="#f2f2f2" strokeWidth="0" />
          <rect x="6" y="18" width="16" height="2" fill="#f2f2f2" strokeWidth="0" />
        </svg>
      );

    default:
      return null;
  }
}
